(() => {
  if (customElements.get('gp-cart-recommendations')) return;
  customElements.define('gp-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.root = window.Shopify?.routes?.root || '/';
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        // Remove newly purchased recommendations immediately, including on a failed refresh.
        const items = event.cartData?.items;
        if (Array.isArray(items)) {
          const ids = new Set(items.map(item => String(item.product_id)));
          this.querySelectorAll('[data-recommended-product-id]').forEach(card => {
            if (ids.has(card.dataset.recommendedProductId)) card.remove();
          });
          if (!items.length || !this.querySelector('[data-recommended-product-id]')) this.hidden = true;
        }
        this.controller?.abort();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(true), 150);
      });
      this.onPageShow = event => { if (event.persisted) this.refresh(true); };
      window.addEventListener('pageshow', this.onPageShow);
      this.refresh(false);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      clearTimeout(this.timer);
      this.controller?.abort();
      window.removeEventListener('pageshow', this.onPageShow);
    }
    async load(url, signal) {
      const response = await fetch(url, { signal, cache: 'no-store' });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = doc.querySelector('gp-cart-recommendations');
      if (!result) throw new Error('Recommendations missing');
      return result;
    }
    apply(result, signal) {
      if (signal.aborted || !this.isConnected) return;
      this.innerHTML = result.innerHTML;
      this.dataset.seedId = result.dataset.seedId || '';
      this.hidden = result.hidden;
    }
    async refresh(cartChanged) {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      try {
        if (cartChanged) {
          const url = new URL(`${this.root}cart`, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          this.apply(await this.load(url, signal), signal);
        }
        if (signal.aborted || !this.dataset.seedId) return;
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('product_id', this.dataset.seedId);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');
        this.apply(await this.load(url, signal), signal);
      } catch { /* Keep the server-rendered fallback; checkout remains independent. */ }
    }
  });
})();
